import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Globe from 'react-globe.gl';

export default function Home() {
  return (
    <div style={{ padding: '2rem', maxWidth: '900px', margin: 'auto' }}>
      <h2>Welcome</h2>
      <br />
      <p>Portfolio - A collection of maps and other gis relative project.</p>
      <br />
      <p>Map - An interactive map.</p>
      <br />
      <p>  Globe - A 3D visualization of the earth with different type of layers.</p>  
      <br />
      <p>Contact - Get in touch for inquiries or collaborations.</p>
      <br />
      <p>About - Information about gisvec and cartacq.</p>
    </div>
  );
}